// extracted by extract-css-chunks-webpack-plugin
module.exports = {"qualificationsError":"activity__qualificationsError--1h9_7"};